import React from 'react';
import {Col, Row} from 'reactstrap';
import {isArray, keys} from 'lodash';
import cx from 'classnames';
import styles from './SectionContents.module.scss';

function SectionContents(props) {
  const {children, sizes, className} = props;

  if (!children) return null;

  const _children = isArray(children) ? children : [children]; // supports 1 children

  return (
    <Row className={cx(className, styles['section-contents'])}>
      {_children.map((child, index) => {
        const colProps = keys(sizes).reduce((accumulate, breakpoint) => {
          accumulate[breakpoint] = sizes[breakpoint][index] || 12; // fallback to 12
          return accumulate;
        }, {});

        return (
          <Col key={index} {...colProps}>
            {child}
          </Col>
        );
      })}
    </Row>
  );
}

SectionContents.defaultProps = {
  sizes: {lg: [6, 6], md: [12, 12], sm: [12, 12]},
};

export default SectionContents;
